module.exports = __webpack_public_path__ + "static/media/curriculum_s5.33ce225c.png";